export default __webpack_public_path__ + "static/media/atza-graphic.ed7b8b3b.jpg";